import { useState } from "react";
import { t } from "@/i18n-js/instance";
import {
  SPACE_DATE_RANGE,
  type SpaceDateRange,
} from "@/react/types/AiSummary/SpaceSummary";
import { StandardLayoutHeaderWithPortal } from "@circle-react/components/Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { SortByDropdown } from "@circle-react/components/Spaces/Header/SpaceHeaderActions/SortByDropdown";
import { SummarizeDropdown } from "@circle-react/components/Spaces/Header/SpaceHeaderActions/SummarizeDropdown";
import { useAiSummariesEnabled } from "@circle-react/components/Spaces/hooks/useAiSummariesEnabled";
import { usePunditUserContext } from "@circle-react/contexts";
import { useCanCreatePost } from "@circle-react/hooks/posts/useCanCreatePost";
import { HomePageNewPostButton } from "../HomePageNewPostButton";
import { FeedSummary } from "./FeedSummary";
import { HomeHeaderTitle } from "./HomeHeaderTitle";
import { ManageFeedActionsV3 } from "./ManageFeedActionsV3";

export interface HomePageHeaderProps {
  updateSortPreference: (sortPreference: string) => void;
  defaultSort: string;
}

export const HomePageHeader = ({
  updateSortPreference,
  defaultSort,
}: HomePageHeaderProps) => {
  const { canCreatePost: shouldDisplayNewPostButton } = useCanCreatePost();

  const [isSummarizeOpen, setIsSummarizeOpen] = useState(false);
  const [dateRange, setDateRange] = useState<SpaceDateRange>(
    SPACE_DATE_RANGE.LAST_7_DAYS,
  );

  const { currentCommunity } = usePunditUserContext();
  const hasAiSpacesSummariesEnabled = useAiSummariesEnabled();

  return (
    <StandardLayoutHeaderWithPortal
      leftContent={
        <HomeHeaderTitle defaultSort={defaultSort} hasDropdown={false} />
      }
      rightContent={
        <div className="hidden items-center gap-6 md:flex">
          {hasAiSpacesSummariesEnabled && (
            <SummarizeDropdown
              onClick={range => {
                setDateRange(range);
                setIsSummarizeOpen(true);
              }}
            />
          )}
          <SortByDropdown
            onChange={updateSortPreference}
            defaultSort={defaultSort}
          />
          {shouldDisplayNewPostButton && <HomePageNewPostButton />}
          <ManageFeedActionsV3 />
        </div>
      }
    >
      {isSummarizeOpen && (
        <FeedSummary
          isOpen={isSummarizeOpen}
          onClose={() => setIsSummarizeOpen(false)}
          dateRange={dateRange}
          sourceName={t("ai_spaces_summaries.feed", {
            community_name: currentCommunity?.name || "",
          })}
        />
      )}
    </StandardLayoutHeaderWithPortal>
  );
};
